import { Action } from '../react/SceneViewer';
import { GizmoData } from '../../SceneLoader';
import { GizmoElement } from '../react/GizmoElement';
import { GroupProps } from '@react-three/fiber';
import { Html } from '@react-three/drei';
import React from 'react';

interface GizmoProps extends GroupProps {
  gizmoData: GizmoData;
  onClick: () => void;
  dispatch: React.Dispatch<Action>;
}

const Gizmo: React.FC<GizmoProps> = ({
  gizmoData,
  onClick,
  dispatch,
  ...props
}) => {
  return (
    <group {...props}>
      <Html zIndexRange={[0, 1]}>
        <GizmoElement data={gizmoData} onClick={onClick} />
      </Html>
    </group>
  );
};
export default Gizmo;
